module.exports = __webpack_public_path__ + "static/media/d6.cbf45d7c.png";